import TrombinoscopeTemplate from "@project/templates/trombinoscope/TrombinoscopeTemplate";
export default {
    key: "TROMBINOSCOPE",
    label: "Trombinoscope",
    templateImage: "/template-trombinoscope.png",
    Component: TrombinoscopeTemplate,
    initialContents: [
        {
            label: "dynamic",
            type: "DYNAMIC",
            dynamicChildKey: "dynamicElements",
            key: "dynamicPart",
            value: "",
            children: [
                {
                    children: [
                        {
                            children: [
                                {
                                    children: [
                                        {
                                            children: [],
                                            type: "FILE_IMAGE",
                                            key: "file",
                                            value: '{"url":"/avatar-placeholder.png","title":"","alt":""}',
                                        },
                                        {
                                            children: [],
                                            type: "INPUT",
                                            value: "",
                                            key: "alt",
                                        },
                                        {
                                            children: [],
                                            type: "INPUT",
                                            value: "",
                                            key: "title",
                                        },
                                        {
                                            children: [],
                                            type: "SELECT",
                                            key: "position_verticale",
                                            value: "top",
                                        },
                                        {
                                            children: [],
                                            type: "SELECT",
                                            key: "position_horizontale",
                                            value: "center",
                                        },
                                        {
                                            children: [],
                                            type: "SELECT",
                                            key: "position_ajustement",
                                            value: "cover",
                                        },
                                        {
                                            children: [
                                                {
                                                    children: [],
                                                    type: "CHECKBOX",
                                                    key: "activated",
                                                    value: "false",
                                                },
                                                {
                                                    children: [],
                                                    type: "SLIDER",
                                                    value: "1",
                                                    key: "opacity",
                                                },
                                                {
                                                    children: [],
                                                    type: "SLIDER",
                                                    value: "0",
                                                    key: "blur",
                                                },
                                                {
                                                    children: [],
                                                    type: "SLIDER",
                                                    value: "0",
                                                    key: "grayscale",
                                                },
                                                {
                                                    children: [],
                                                    type: "SLIDER",
                                                    value: "1",
                                                    key: "brightness",
                                                },
                                                {
                                                    children: [],
                                                    type: "SLIDER",
                                                    value: "1",
                                                    key: "saturate",
                                                },
                                                {
                                                    children: [],
                                                    type: "SLIDER",
                                                    value: "0",
                                                    key: "sepia",
                                                },
                                            ],
                                            type: "IMAGE_FILTERS",
                                            key: "filters",
                                            value: "",
                                        },
                                    ],
                                    type: "IMAGE",
                                    key: "image",
                                    value: "",
                                },
                                {
                                    children: [
                                        {
                                            children: [],
                                            type: "FILE_IMAGE",
                                            key: "file",
                                            value: '{"url":"/avatar-placeholder-hover.png","title":"","alt":""}',
                                        },
                                        {
                                            children: [],
                                            type: "INPUT",
                                            value: "",
                                            key: "alt",
                                        },
                                        {
                                            children: [],
                                            type: "INPUT",
                                            value: "",
                                            key: "title",
                                        },
                                        {
                                            children: [],
                                            type: "SELECT",
                                            key: "position_verticale",
                                            value: "top",
                                        },
                                        {
                                            children: [],
                                            type: "SELECT",
                                            key: "position_horizontale",
                                            value: "center",
                                        },
                                        {
                                            children: [],
                                            type: "SELECT",
                                            key: "position_ajustement",
                                            value: "cover",
                                        },
                                        {
                                            children: [
                                                {
                                                    children: [],
                                                    type: "CHECKBOX",
                                                    key: "activated",
                                                    value: "false",
                                                },
                                                {
                                                    children: [],
                                                    type: "SLIDER",
                                                    value: "1",
                                                    key: "opacity",
                                                },
                                                {
                                                    children: [],
                                                    type: "SLIDER",
                                                    value: "0",
                                                    key: "blur",
                                                },
                                                {
                                                    children: [],
                                                    type: "SLIDER",
                                                    value: "0",
                                                    key: "grayscale",
                                                },
                                                {
                                                    children: [],
                                                    type: "SLIDER",
                                                    value: "1",
                                                    key: "brightness",
                                                },
                                                {
                                                    children: [],
                                                    type: "SLIDER",
                                                    value: "1",
                                                    key: "saturate",
                                                },
                                                {
                                                    children: [],
                                                    type: "SLIDER",
                                                    value: "0",
                                                    key: "sepia",
                                                },
                                            ],
                                            type: "IMAGE_FILTERS",
                                            key: "filters",
                                            value: "",
                                        },
                                    ],
                                    type: "IMAGE",
                                    key: "imageHover",
                                    value: "",
                                },
                                {
                                    children: [],
                                    type: "INPUT",
                                    value: "Nom",
                                    key: "name",
                                },
                                {
                                    children: [],
                                    type: "INPUT",
                                    value: "Prénom",
                                    key: "firstName",
                                },
                                {
                                    children: [],
                                    type: "INPUT",
                                    value: "Lead Squad",
                                    key: "position",
                                },
                                {
                                    children: [],
                                    type: "URL",
                                    key: "link",
                                    value: "",
                                },
                                {
                                    children: [],
                                    type: "COLOR",
                                    key: "textColor",
                                    value: "#FFFFFF",
                                },
                                {
                                    children: [],
                                    type: "COLOR",
                                    key: "textColorHover",
                                    value: "#27272B",
                                },
                                {
                                    children: [],
                                    type: "COLOR",
                                    key: "backgroundColor",
                                    value: "#0000FF",
                                },
                                {
                                    children: [],
                                    type: "COLOR",
                                    key: "backgroundColorHover",
                                    value: "#FFFF80",
                                },
                            ],
                            type: "TROMBINOSCOPE",
                            key: "items",
                            value: "",
                        },
                        {
                            children: [],
                            key: "size",
                            type: "SELECT_GRID",
                            value: "3",
                        },
                        {
                            children: [],
                            key: "sizeSm",
                            type: "SELECT_GRID",
                            value: "6",
                        },
                        {
                            children: [],
                            key: "sizeXs",
                            type: "SELECT_GRID",
                            value: "12",
                        },
                        {
                            children: [],
                            type: "SELECT",
                            key: "justify",
                            value: "center",
                        },
                        {
                            children: [],
                            type: "SELECT",
                            key: "alignItems",
                            value: "center",
                        },
                        {
                            children: [],
                            type: "SLIDER",
                            value: "40",
                            key: "spacing",
                        },
                        {
                            children: [],
                            type: "SLIDER",
                            value: "20",
                            key: "mobileSpacing",
                        },
                    ],
                    type: "GRID",
                    key: "dynamicElements",
                    value: "",
                },
                {
                    children: [
                        {
                            children: [],
                            type: "SLIDER",
                            value: "30",
                            key: "height",
                        },
                        {
                            children: [],
                            type: "SLIDER",
                            value: "30",
                            key: "mobileHeight",
                        },
                    ],
                    type: "MARGIN",
                    value: "",
                    key: "dynamicElements",
                },
                {
                    children: [
                        {
                            children: [],
                            type: "INPUT",
                            value: "Un projet à lancer, une équipe à mobiliser ?",
                            key: "title",
                        },
                        {
                            children: [],
                            type: "INPUT",
                            value: "Bénéficiez d'un accompagnement global porté par une équipe d'experts engagés",
                            key: "subtitle",
                        },
                        {
                            children: [
                                {
                                    children: [],
                                    type: "INPUT",
                                    value: "/contact",
                                    key: "url",
                                },
                                {
                                    children: [],
                                    type: "INPUT",
                                    value: "Nous contacter",
                                    key: "title",
                                },
                                {
                                    children: [],
                                    type: "PAGE",
                                    key: "page",
                                    value: "",
                                },
                                {
                                    children: [],
                                    type: "CHECKBOX",
                                    key: "external",
                                    value: "false",
                                },
                            ],
                            type: "LINK",
                            key: "link",
                            value: "",
                        },
                    ],
                    type: "CONTACT_BLOCK",
                    key: "dynamicElements",
                    value: "",
                },
            ],
        },
    ],
};
